import ColumnAvatar from '../components/Redesing/column-avatar';
import PersonIcon from '@mui/icons-material/Person';
import { Typography } from '@mui/material';
import { SeverityPill } from '../components/Redesing/severity-pill';
import { IColumn } from '../ts/interface/components/redesing/table.interface';
import { IUserDetail } from '../ts/interface/userDetail.interface';
// import { formatPhoneNumber } from 'react-phone-number-input';
import { getLocaleDateString } from '../utils';

export const userColumns: IColumn[] = [
  {
    id: 'fullName',
    label: 'User',
    searchable: true,
    showToolTip: true,
    maxWidth: '350px',
    exportFormat: (cell: IUserDetail) => cell.fullName,
    format: (cell: IUserDetail) => {
      return (
        <ColumnAvatar
          avatar={<PersonIcon />}
          firstRow={
            <Typography color="text.pramary" variant="body1">
              {cell.fullName}
            </Typography>
          }
          secondRow={
            <Typography color="text.secondary" variant="body2">
              <SeverityPill color={'info'}>{cell.emailAddress}</SeverityPill>
            </Typography>
          }
        />
      );
    },
  },
  {
    id: 'phone',
    label: 'Phone #',
    searchable: true,
    useFormatInSearch: true,
    notSortable: true,
    exportFormat: (cell: IUserDetail) => cell.phone,
    format: (cell: IUserDetail) => cell.phone,
  },
  {
    id: 'joined',
    label: 'Joined',
    exportFormat: (cell: IUserDetail) => getLocaleDateString(cell.joined),
    format: (cell: IUserDetail) => getLocaleDateString(cell.joined),
  },
  {
    id: 'emailAddress',
    label: 'Email',
    hidden: true,
    searchable: true,
    notSortable: true,
  },
];
